import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from '@reach/router'
import serverData from './utils/server-data'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'
import ThirdPartyPerms from './ThirdPartyPerm'
import { CacheProvider } from '@emotion/react'
// eslint-disable-next-line import/named
import { PAYPAL_THEME, ThemeWrapper } from '@paypalcorp/pp-react'
import createCache from '@emotion/cache'
import './ThirdPartyPerm/pages/styles/styles.css'
import './AccountAuth/styles/styles.css'
import './baseStyles/styles.css'
import {
  accessPermissionLogin,
  accountAuthenticateLogin,
  baseURL,
  managePermissions,
  saveUserDetails,
} from './utils/constants'
import DefaultPage from './ThirdPartyPerm/pages/defaultPage'
import SaveUserDetails from './AccountAuth/saveUserDetails'
import AccountAuth from './AccountAuth'

const styleRoot = document.getElementById('custom-style')

const myCache = createCache({
  key: 'identitylegacynodewebcache',
  container: styleRoot,
})

let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

ReactDOM.render(
  <WorldReadyContextProvider locale={serverData.locality.locale || 'en-US'}>
    <CacheProvider value={myCache}>
      <ThemeWrapper theme={PAYPAL_THEME}>
        <Router basepath={baseURL}>
          <ThirdPartyPerms path={managePermissions} />
          <DefaultPage default />
          <AccountAuth
            path={accountAuthenticateLogin}
            loginPageInfo="account_authenticate_login"
          />
          <AccountAuth
            path={accessPermissionLogin}
            loginPageInfo="access_permission_login"
          />
          <SaveUserDetails path={saveUserDetails} />
        </Router>
      </ThemeWrapper>
    </CacheProvider>
  </WorldReadyContextProvider>,
  root,
)
